export const USER_FEATURE_USAGE = {
    BACKGROUND_REMOVAL: 'backgroundRemoval',
} as const;

export const USER_FEATURE_USAGE_PERIOD = {
    MONTH: 'month',
} as const;

export type UserFeatureUsage = (typeof USER_FEATURE_USAGE)[keyof typeof USER_FEATURE_USAGE];
export type UserFeatureUsagePeriod = (typeof USER_FEATURE_USAGE_PERIOD)[keyof typeof USER_FEATURE_USAGE_PERIOD];

/** Guards untrusted feature names (e.g. route params) before they reach usage lookups. */
export const isUserFeatureUsage = (value: unknown): value is UserFeatureUsage =>
    Object.values(USER_FEATURE_USAGE).includes(value as UserFeatureUsage);

/**
 * A user's usage within the current period of a feature's limit, for display in clients.
 * The limit is resolved server-side from the user's tier; null means uncapped.
 */
export type UserFeatureUsageSummary = {
    feature: UserFeatureUsage;
    count: number;
    limit: number | null;
};

export type MNUserFeatureUsage = {
    userId: string;
    feature: UserFeatureUsage;
    periodKey: string;
    count: number;
    createdAt: number;
    updatedAt: number;
};
